export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthArea_02.5bc652a1.jpg";